/*
akhila    10/28/2022 3075154998 enable framework UX changes
 */
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddEnableFileFormatForm from './AddEnableFileFormat/AddEnableFileFormatForm';
import SearchEnableFileFormat from './SearchEnableFileFormat/index';


const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function EnableFileFormatTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [enableCode, setEnableCode] = useState('');
  const [dataReset, setResetData] = useState('');
  const [calledId, setCalledId] = useState([]);
  return (
    <div className={classes.root}>
      <div>
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchEnableFileFormat setTabValue={setValue} setEnableCode={setEnableCode} setResetData={setResetData}/>
        ) :
          value === 1 ? (
            <AddEnableFileFormatForm
              setValue={setValue}
              enableCode={enableCode}
              calledId={calledId}
              setCalledId={setCalledId}
              dataReset={dataReset}
            />
          ) : null}
      </div>
    </div>
  );
}
